function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Error validation
 * 
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class ErrorValidation extends React.Component {
  render() {
    const {
      errors
    } = this.props;
    if (errors === 0) return null;
    return /*#__PURE__*/_jsxs("div", {
      className: "pre-footer error",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: "triangle-exclamation",
        inverse: true
      }), "We found ", errors, " ", errors === 1 ? 'error' : 'errors', " in the information provided above.", /*#__PURE__*/_jsx("br", {}), "Please fix the highlighted fields and try again."]
    });
  }
}
_defineProperty(ErrorValidation, "defaultProps", {
  errors: 0
});
export default ErrorValidation;